import { FC, useEffect, useRef } from 'react';
import { connect, ConnectedProps, shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as auth from './AuthRedux';
import { RootState } from '../../setup';
import { UserModel } from '../models/UserModel';
import { parseJwt } from '../views/login/Login';
import { BASE_URL } from '../../config/environmentConfig';
import axios from 'axios';
import { sendSentryMessage } from '../utils/sentry-helper';

const mapState = (state: RootState): RootState => ({ auth: state.auth });
const connector = connect(mapState, auth.actions);
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
	const didRequest = useRef(false);
	const dispatch = useDispatch();
	const auth: any = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	// We should request user by authToken before rendering the application
	useEffect(() => {
		const requestUser = async (arg): Promise<() => boolean> => {
			try {
				if (!didRequest.current) {
					dispatch(props.fulfillUser(arg ? arg : auth?.userData as UserModel));
				}
			} catch (error) {
				console.error(error);
				if (!didRequest.current) {
					dispatch(props.logout());
				}
			}
			return (): boolean => (didRequest.current = true);
		};

		if (auth?.accessToken) {
			if (auth?.userData?.applicationStatus === 'CANCELLED') {
				dispatch(props.logout());
			}
			requestUser(null);
		} else {
			const idToken = localStorage.getItem('idToken');
			const accessToken = localStorage.getItem('accessToken');

			if (idToken && accessToken) {
				const parsedToken = parseJwt(idToken);
				const userGroups = parsedToken?.['cognito:groups'];
				const applicationId = parsedToken?.['custom:mid'];

				try {
					const STATUS_URL = `${BASE_URL.MERCHANTS}/onboarding/${applicationId}/status`;
					const LIST_URL = `${BASE_URL.MERCHANTS}/lists`;

					axios(STATUS_URL, { headers: { Authorization: `Bearer ${idToken}` }})
						.then(res => {
							const status = res?.data?.status;

							axios(LIST_URL)
								.then(res => {
									const list = res?.data?.applicationStatuses;

									dispatch(auth.actions.login({
										accessToken,
										idToken,
										userData: {
											userId: parsedToken?.['cognito:username'],
											email: parsedToken?.email,
											emailVerified: parsedToken?.email_verified,
											userGroups,
											applicationStatus: list?.[status],
											loginDate: new Date(),
										}
									}));
									requestUser({
										userId: parsedToken?.['cognito:username'],
										email: parsedToken?.email,
										emailVerified: parsedToken?.email_verified,
										userGroups,
										applicationStatus: list?.[status],
									});
								});
						});

				} catch (e) {
					sendSentryMessage({ name: `GET Logout error`, context: e });
					dispatch(props.logout());
				}
			} else {
				dispatch(props.logout());
			}
		}
		// eslint-disable-next-line
	}, []);

	// @ts-ignore
	return <>{props.children}</>;
};

export default connector(AuthInit);
